// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__vrWZj","brand":"Navbar_brand__Ihedg","links_list":"Navbar_links_list__zJIUX","active":"Navbar_active__N8TwG"};